<template>
    <v-dialog
      v-model="dialogComputed"
      max-width="900px"
      scrollable
    >
        <v-card class="custom-positioned-dialog">
            <v-card-title>
                <v-icon icon="mdi-account-multiple-outline"></v-icon>
                Assign ({{ selectedSubItems.length }})

                <v-tooltip text="Select All" location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn v-bind="props"
                               @click="selectAllUsers"
                               variant="text">
                            <v-icon>mdi-select-all</v-icon>
                        </v-btn>
                    </template>
                </v-tooltip>
                <v-tooltip text="Deselect All" location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn v-bind="props"
                               @click="deselectAllUsers"
                               variant="text">
                            <v-icon>mdi-select-off</v-icon>
                        </v-btn>
                    </template>
                </v-tooltip>
            </v-card-title>
            <v-card-text>
                <v-alert type="info" variant="tonal" class="mb-4">
                    Select one or more users to assign to
                </v-alert>

                <v-list>
                    <v-list-item 
                                             v-for="user in (teamUsers[localSelectedTeam] || [])"
                                             :key="user.id"
                                             @click="toggleUserSelection(user.id)">
                                    <template v-slot:prepend>
                                        <v-checkbox v-model="selectedUsers"
                                                    :value="user.id"
                                                    density="compact"
                                                    hide-details
                                                    class="ma-0 pa-0 mr-2"
                                                    @click.stop></v-checkbox>
                                        <v-avatar :size="28"
                                                  class="mr-1">
                                            <v-img v-if="user.avatarUrl"
                                                   :src="getAvatarUrl(user.avatarUrl)"
                                                   alt="User Avatar"></v-img>
                                            <span v-else
                                                  class="d-flex justify-center align-center text-caption white--text"
                                                  :style="{
                                backgroundColor: getRandomColor(user.id),
                                width: '100%',
                                height: '100%',
                                borderRadius: '50%'
                              }">
                                                {{ getInitials(user.displayName) }}
                                            </span>
                                        </v-avatar>
                                    </template>
                                    <v-list-item-title>{{ user.displayName }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ user.roleTitle }}</v-list-item-subtitle>
                                    <template v-slot:append>
                                        <v-chip>{{ getUserItemCount(user.id) }}</v-chip>
                                    </template>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="closeDialog">
                    Cancel
                </v-btn>
                <v-btn color="primary" @click="assignTeam">
                    Assign
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog :model-value="assigning" persistent max-width="300">
    <v-card>
      <v-card-text>
        Assigning items...
        <v-progress-linear
          indeterminate
          color="primary"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  </template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
